import ApiService from "../api";

export default class VersaoAppService extends ApiService {

    constructor() {
        super('/api/solicitacoes/app-versoes')
    }

    listar() {
        return this.get(``);
    }

    publicar(arquivo, notas, obrigatoria, onProgresso) {
        const formData = new FormData()
        formData.append("arquivo", arquivo)
        formData.append("notas", notas || "")
        formData.append("obrigatoria", obrigatoria ? "true" : "false")

        return this.post(``, formData, {
            onUploadProgress: evento => {
                if (onProgresso && evento.total) {
                    onProgresso(Math.round((evento.loaded / evento.total) * 100))
                }
            }
        })
    }

    baixar(id) {
        return this.fileDownload(`/${id}/download`)
    }

    excluir(id) {
        return this.delete(`/${id}`);
    }
}
